import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Films from "@/pages/films/page";
import FilmDetail from "@/pages/film-detail/page";
import Screenings from "@/pages/screenings/page";
import Technology from "@/pages/technology/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "films", element: <Films /> },
      { path: "films/:id", element: <FilmDetail /> },
      { path: "screenings", element: <Screenings /> },
      { path: "technology", element: <Technology /> },
      { path: "guide", element: <Guide /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;